import { z } from '../utils/zod-extend'

export const themeSchema = z.object({
  mainColor: z.string().max(7).optional(),
  mainTextColor: z.string().max(7).optional(),
  bodyTextColor: z.string().max(7).optional(),
})

export type ThemeConfig = z.infer<typeof themeSchema>
